import { useCallback } from 'react';
import axios, { AxiosError } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { raiseToast } from '@fiverr-private/toast';
import { translate } from '@fiverr-private/i18n-react';
import { RecommendedSeller } from '../../types/seller';
import { useLandingPage } from '../context/LandingPageContext';

export function useRegenerateSellers() {
    const {
        setIsMatchSellersLoading,
        briefBoxInputValue,
        setSellers,
        sellers,
        sellerIdsToExclude,
        setSellerIdsToExclude,
    } = useLandingPage();

    const regenerateSellers = useCallback(async () => {
        setIsMatchSellersLoading(true);

        try {
            if (!briefBoxInputValue) {
                throw new Error('Brief is required');
            }

            const newSellerIdsToExclude = [...sellerIdsToExclude, ...sellers.map((seller) => seller.seller.id)];
            setSellerIdsToExclude(newSellerIdsToExclude);

            const url = pathfinder('vibe_coding_post_regenerate_sellers');
            const response = await axios.post<RecommendedSeller[]>(url, {
                brief: briefBoxInputValue,
                sellerIdsToExclude: newSellerIdsToExclude.map((value: number) => value.toString()),
            });

            setSellers(response.data);
        } catch (err) {
            const message =
                err instanceof AxiosError && err.response?.status === 422
                    ? 'Brief is incompatible for sellers generation. Please update the brief.'
                    : translate('vibe_coding_perseus.seller_message.something_went_wrong');
            raiseToast({
                type: 'error',
                location: 'top',
                message,
            });
        } finally {
            setIsMatchSellersLoading(false);
        }
    }, [briefBoxInputValue, setSellers, setIsMatchSellersLoading, sellerIdsToExclude, sellers, setSellerIdsToExclude]);

    return {
        regenerateSellers,
    };
}
